//
import Model from "@/models/Model"

/**
 * 
 */
export default class SlCheck extends Model {

    //
    static includes = [        
        "g_bank",
        "pos_payment_check_type",
        "sl_check_status",
    ]

    get g_bank_bank() {
        return this.getProperty('g_bank.bank', '-')
    }

    get sl_check_status_status() {
        return this.getProperty('sl_check_status.status', '-')
    }

    /**
     * 
     */
    resource() {
        return "sl_check"
    }

    updateStatus(id,data){
        const route = this.baseURL()+"/"+this.resource() +"/"+id+"/status"

        return new Promise((resolve,reject)=>{
            this.$http.post(route,data)
            .then(function(response){
                resolve( response)
            })
            .catch(function (error){
                reject( error )
            })
        })
    }
}